import api from "./api";

const BASE_PATH = "domain-plans";

function sanitizeDomainPlanPayload(payload = {}) {
  const {
    clientEmail,
    projectId,
    product,
    renewalDate,
    effectiveDate,
    pricePerYear,
    pricePerYearEURO,
    pricePerYearRON,
    extendTime,
    paymentIntentId,
    lastPaymentDate,
    paymentUpdateTimestamp,
    previousProjectId,
  } = payload;

  const cleaned = {
    clientEmail:
      typeof clientEmail === "string" ? clientEmail.trim().toLowerCase() : "",
    projectId: typeof projectId === "string" ? projectId.trim() : "",
    product: typeof product === "string" ? product.trim().toLowerCase() : "",
    renewalDate: renewalDate || "",
    effectiveDate: effectiveDate || "",
    extendTime: typeof extendTime === "string" ? extendTime : "1 year",
    ...(paymentIntentId && { paymentIntentId: paymentIntentId.trim() }),
    ...(lastPaymentDate && { lastPaymentDate }),
    ...(paymentUpdateTimestamp && { paymentUpdateTimestamp }),
    ...(previousProjectId && { previousProjectId: previousProjectId.trim() }),
  };

  if (pricePerYearEURO !== undefined) {
    cleaned.pricePerYearEURO = Number(pricePerYearEURO ?? 0);
  }
  if (pricePerYearRON !== undefined) {
    cleaned.pricePerYearRON = Number(pricePerYearRON ?? 0);
  }
  if (pricePerYear !== undefined) {
    cleaned.pricePerYear = Number(pricePerYear ?? 0);
  }

  return cleaned;
}

function normalizeAxiosError(error) {
  const message =
    error?.response?.data?.message || error?.message || "Request failed";
  const err = new Error(message);
  err.status = error?.response?.status;
  err.data = error?.response?.data;
  return err;
}

export async function createDomainPlan(payload) {
  try {
    const body = sanitizeDomainPlanPayload(payload);
    const { data } = await api.post(BASE_PATH, body);
    return data;
  } catch (error) {
    throw normalizeAxiosError(error);
  }
}

export async function getDomainPlans(params = {}) {
  try {
    const { data } = await api.get(BASE_PATH, { params });
    return data;
  } catch (error) {
    throw normalizeAxiosError(error);
  }
}

export async function getUserDomainPlans(params = {}) {
  try {
    const { data } = await api.get(`${BASE_PATH}/my-domains`, { params });
    return data;
  } catch (error) {
    return {
      success: false,
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch user domain plans",
    };
  }
}
